<template>
  <div :class="formGroupClass" class="tangibles-form">
    <slot name="before"/>
    <input
      class="form-control"
      :id="tangiblesKey"
      autocomplete="off"
      v-model="inputValue"
      @input="emit"
      @change="emit"
      @blur="emit"
      @keyup.delete="emit"
      :disabled="disabled"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import passSectionMixin from '@/common/mixins/application-form/passSectionMixin';

export default {
  name: 'TangiblesInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin
  ],

  props: {
    inputLabel: {
      default: ''
    },

    inputName: {
      default: 'tangibles'
    },

    tangiblesId: {
      type: [Number],
      default: null
    }
  },

  computed: {
    tangiblesKey () {
      return `form-pass-tangibles-input-${this.tangiblesId}`
    },

    inputError () {
      return this.hasInputErrors ? 'Введите наименование' : null
    },

    hasInputErrors () {
      return this.errors.application?.tangibles !== undefined &&
        this.errors.application?.tangibles[this.tangiblesId] &&
        this.errors.application?.tangibles[this.tangiblesId].find((err) => err === 'name')
    }
  }
}
</script>
